function convertToCSS(jsonData, containerId) {
    let cssString = '';
    let mobileCSSContent = ''; // Store all mobile styles
    let hasMobileStyles = false; // Track if we need to declare media query

    const sortedKeys = Object.keys(jsonData).sort((a, b) => {
        const aIsCustom = a.includes("custom");
        const bIsCustom = b.includes("custom");

        // Sort 'custom' keys after non-'custom' keys
        if (aIsCustom && !bIsCustom) return 1;
        if (!aIsCustom && bIsCustom) return -1;

        // If both keys are 'custom', sort in descending order
        if (aIsCustom && bIsCustom) return b.localeCompare(a);

        // Otherwise, sort in ascending order
        return a.localeCompare(b);
    });

    const sortedObj = sortedKeys.reduce((acc, key) => {
        acc[key] = jsonData[key];
        return acc;
    }, {});

    for (const className in sortedObj) {
        const properties = sortedObj[className];
        if (Object.keys(properties).length === 0) continue; // Skip empty objects

        let classCSS = `#${containerId} .${className} {\n`;
        for (const property in properties) {
            const cssProperty = property.replace(/_/g, '-');
            classCSS += `  ${cssProperty}: ${properties[property]};\n`;
        }
        classCSS += `}\n`;

        // If the className contains both "custom" and "mob", add it to mobile styles
        if (className.includes("custom") && className.includes("mob")) {
            mobileCSSContent += classCSS;
            hasMobileStyles = true;
        } else {
            cssString += classCSS;
        }
    }

    // Wrap all mobile styles in a single media query
    if (hasMobileStyles) {
        cssString += `@media (max-width: 768px) {\n${mobileCSSContent}}\n`;
    }

    return cssString;
}

export default convertToCSS;